<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="main-top-group">
	<!-- 		 	     -->
	<!-- Person Selector -->
	<!-- 			 	 -->
	<div class="personselector-group" [style.display]="isEditMode == true ? 'none' : 'flex'">
		<caass-personselector
			[AudienceID]="2"
			[CanSwitchAudience]="false"
			[ShowAllSchools]="false"
			[MultiSelect]="false"
		></caass-personselector>
	</div>

	<!--  	   	 	 -->
	<!-- TOP SECTION -->
	<!-- 			 -->
	<div class="column-group">
		<div class="column1">
			<!--  	   	    -->
			<!-- Staff Name -->
			<!-- 		    -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Collected By:</label>
				</div>

				<div style="margin-left: 10px">
					<label style="color: #d19a02">{{ ItemCollectionStaffAddEditInfo.LogByFullName }}</label>
				</div>
			</div>

			<!--  	   	  		 -->
			<!-- Collection Date -->
			<!-- 				 -->
			<div class="column-item" [style.display]="isEditMode == false ? 'none' : 'flex'">
				<div>
					<label class="column-item-label">Collection Date:</label>
				</div>

				<div style="margin-left: 10px">
					<label style="color: #d19a02">{{ ItemCollectionStaffAddEditInfo.CollectionDTDesc }}</label>
				</div>
			</div>

			<!--  	   	   -->
			<!-- StaffID -->
			<!-- 		   -->
			<div class="column-item" [style.display]="isEditMode == false ? 'none' : 'flex'">
				<div>
					<label class="column-item-label">StaffID:</label>
				</div>

				<div style="margin-left: 10px">
					<label style="color: blue">{{ ItemCollectionStaffAddEditInfo.StaffID }}</label>
				</div>
			</div>

			<!--  	   	      -->
			<!-- Staff Name -->
			<!-- 		      -->
			<div class="column-item" [style.display]="isEditMode == false ? 'none' : 'flex'">
				<div>
					<label class="column-item-label">Staff Name:</label>
				</div>

				<div style="margin-left: 10px">
					<label style="color: blue">{{ ItemCollectionStaffAddEditInfo.FullName }}</label>
				</div>
			</div>

			<!--  	   	             -->
			<!-- ItemClass Selector  -->
			<!-- 		             -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Item Type:</label>
				</div>

				<div style="margin-left: 10px; width: 300px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="ItemClassSelector"
						style="font-size: smaller"
						[(ngModel)]="SelectedScanPersonalItemClass"
						(ngModelChange)="onPersonalItemClassChange($event)"
					>
						<option *ngFor="let r of lstScanPersonalItemClass" [ngValue]="r">
							{{ r.ScanPersonalItemClassDesc }}
						</option>					
					</select>
				</div>
			</div>

			<!--  	   	                 -->
			<!-- ItemCondition Selector  -->
			<!-- 		                 -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Condition:</label>
				</div>

				<div style="margin-left: 10px; width: 300px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="ItemConditionSelector"
						style="font-size: smaller"
						[(ngModel)]="SelectedScanPersonalItemCondition"
						(ngModelChange)="onScanPersonalItemConditionChange($event)"
					>
						<option *ngFor="let r of lstScanPersonalItemCondition" [ngValue]="r">
							{{ r.ScanPersonalItemConditionDesc }}
						</option>	
					</select>
				</div>
			</div>

			<!--  	   	   -->
			<!-- BinNumber -->
			<!-- 		   -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Bin Number:</label>
				</div>

				<div style="margin-left: 10px">
					<textarea class="TextArea" rows="1" [(ngModel)]="ItemCollectionStaffAddEditInfo.BinNumber"></textarea>
				</div>
			</div>			

			<!--  	   	   -->
			<!-- Comments  -->
			<!-- 		   -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Comments:</label>
				</div>

				<div style="margin-left: 10px">
					<textarea class="TextArea" rows="5" [(ngModel)]="ItemCollectionStaffAddEditInfo.ScanPersonalItemDesc"></textarea>
				</div>
			</div>	

			<!--  	   	         -->
			<!-- Changed By Name -->
			<!-- 		         -->
			<div class="column-item" [style.display]="isEditMode == false ? 'none' : 'flex'">
				<div>
					<label class="column-item-label">Changed By:</label>
				</div>

				<div style="margin-left: 10px">
					<label style="color: #d19a02">{{ ItemCollectionStaffAddEditInfo.ChangedByFullName }}</label>
				</div>
			</div>

			<!--  	   	    -->
			<!-- Changed DT -->
			<!-- 		    -->
			<div class="column-item" [style.display]="isEditMode == false ? 'none' : 'flex'">
				<div>
					<label class="column-item-label">Changed On:</label>
				</div>

				<div style="margin-left: 10px">
					<label style="color: #d19a02">{{ ItemCollectionStaffAddEditInfo.ChangedDTDesc }}</label>
				</div>
			</div>

			<!--  	   	   -->
			<!-- Returned  -->
			<!-- 		   -->
			<div class="column-item" [style.display]="isEditMode == false ? 'none' : 'flex'">
				<div>
					<label class="column-item-label">Returned:</label>
				</div>

				<div style="margin-left: 10px">
					<label style="color: blue">{{ ItemCollectionStaffAddEditInfo.Returned }}</label>
				</div>
			</div>
	
		</div>
	</div>
</div>

<!--				-->
<!-- Error Message  -->
<!--				-->
<div class="error-group" [style.display]="ErrorMessage.length == 0 ? 'none' : 'block'">
	<div class="error-div">
		<label class="error-message">{{ ErrorMessage }}</label>
	</div>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div style="margin-top: 20px">
	<button class="btn btn-primary" style="margin-left: 0px" (click)="onAddUpdate()" [disabled]="isBusy == true">Save</button>
	<button class="btn btn-primary" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
